export default {
      id: "graph-cri-usage",
      viewBox: "0 0 128 155",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-cri",
      toString: function () {
        return this.url;
      }
    }